import { call, put, takeLatest } from 'redux-saga/effects' 
import { REGISTER_API_CALL, LOGIN_API_CALL } from '../Actions/actionTypes'
import { register, login } from '../data/API'
import { apiDataStore} from '../Actions/index'


function* hitRegisterApi(body){
    try{
        const response = yield call(register, body.payload) 
        yield put(apiDataStore(response.data)) 
    } catch (e){
        console.log(e)
    }
}

function* hitLogin(body){
    try{
        const response = yield call(login, body.payload) 
        yield put(apiDataStore(response.data)) 
    } catch (e){
        console.log(e)
    }
}
 

export function* watchAuthApi(action) { 
    yield takeLatest(REGISTER_API_CALL, hitRegisterApi) 

    yield takeLatest(LOGIN_API_CALL, hitLogin) 
}

 